import { Contact } from "../internal-contacts";
import { JobChatSummary } from "../job-chats";
import type { MessageGroupSummary } from "../message-groups/messageGroups.types";
import { SmsContact } from "../virtual-receptionist/sms/contacts/types/SmsContact";

export type ChatTarget =
  | {
      type: "sms";
      phoneNumber: string;
      companyId?: number | string | null;
      sessionNumber?: string | null;
      contact?: SmsContact | null;
    }
  | { type: "internal"; contactId: string; companyId?: number | string | null; contact?: Contact | null }
  | { type: "job"; jobEventUid: string; companyId?: number | null; chat?: JobChatSummary | null }
  | { type: "group"; groupUid: string; companyId?: number | string | null; group?: MessageGroupSummary | null };

export interface OpenChat {
  key: string;
  target: ChatTarget;
  companyName: string;
  chatName: string;
  focusMessageUid?: string | null;
  focusMessageText?: string | null;
  minimized: boolean;
  unreadCount: number;
  openedAt: number;
  lastActivityAt: number;
}

export const getChatTargetKey = (target: ChatTarget): string => {
  switch (target.type) {
    case "sms":
      return `sms:${target.companyId ?? "no-company"}:${String(target.phoneNumber).replace(/\D/g, "")}`;
    case "internal":
      return `internal:${target.companyId ?? target.contact?.companyId ?? "no-company"}:${target.contactId}`;
    case "job":
      return `job:${target.jobEventUid}`;
    case "group":
      return `group:${target.groupUid}`;
    default:
      return "unknown";
  }
};
